export default /* istanbul ignore next */ ({ breakpoints }) => ({
  workspaceGroup: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between'
  },
  narrow: {
    display: 'flex',
    width: '50%',
    [`@media only screen and (max-width: ${breakpoints.values.lg}px)`]: {
      width: '100%'
    }
  }
});
